<div class="modal-header">
    <h4 class="modal-title">Invite Crew</h4>
</div>
<div class="modal-body side-panel-body">
    @if (!selected()) {
        <label for="contact-search">Search for an existing contact</label>
        <input
            type="text"
            id="contact-search"
            name="contact-search"
            [formControl]="contactSearch"
            class="text-input"
            placeholder="Search contact name, business name or email address"
            #resultsTrigger="cdkMenuTriggerFor"
            [cdkMenuTriggerFor]="contactSearchResults" />
        <ng-template #contactSearchResults>
            <div class="dropdown-menu-container" cdkMenu>
                @for (contact of contacts(); track contact.iD_Contact) {
                    @let name =
                        contact.name && contact.businessName
                            ? contact.name + ' (' + contact.businessName + ')'
                            : contact.name || contact.businessName;
                    <div class="menu-item" (click)="selectContact(contact)">
                        <label class="no-wrap">{{ name }}</label>
                        @if (contact.email) {
                            <label class="sub-info">{{ contact.email }}</label>
                        }
                    </div>
                }
                @if (hasNext() && !hasError()) {
                    <div class="generic-item" visibilityObserver (onVisible)="loadNext$.next()">
                        <p>Fetching contacts <app-bx-spinner></app-bx-spinner></p>
                    </div>
                }
                @if (!hasNext() && !contacts().length) {
                    <div class="generic-item">
                        <p>No contacts found.</p>
                    </div>
                }
            </div>
        </ng-template>
        <div class="function-button">
            <button id="create-new-contact" type="button" class="btn-bx-secondary-stroked" (click)="createContact()">
                Create new contact
            </button>
        </div>
    } @else {
        @let contact = selected()!;
        <div class="selected-contact">
            <h4 class="header-title">Contact details</h4>
            @if (contact.name) {
                <div class="detail-group">
                    <label class="bold">Name</label>
                    <span>{{ contact.name }}</span>
                </div>
            }
            @if (contact.businessName) {
                <div class="detail-group">
                    <label class="bold">Business name</label>
                    <span>{{ contact.businessName }}</span>
                </div>
            }
            @if (contact.email) {
                <div class="detail-group">
                    <label class="bold">Email address</label>
                    <span>{{ contact.email }}</span>
                </div>
            } @else {
                <div class="detail-group">
                    <label class="bold"><span class="required">*</span> Email address</label>
                    <input type="email" class="text-input" [formControl]="updatedEmail" />
                    @if (updatedEmail.invalid) {
                        <span class="error-text">Enter an email address to send an invitation</span>
                    }
                </div>
            }
        </div>
        <div class="function-button">
            <button id="reset-search" type="button" class="btn-bx-secondary-stroked" (click)="deselectContact()">Reset search</button>
        </div>
    }
</div>
<footer class="modal-footer btn-group-footer">
    <div class="btn-group-right">
        <button id="cancel" type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
        @let selectedHasNoEmail = selected() && !selected()?.email;
        <button
            id="send-invitation"
            type="button"
            class="btn-bx-primary ml-2"
            (appSingleClick)="sendInvitation()"
            [disabled]="sending() || !selected() || (selectedHasNoEmail && updatedEmail.invalid)">
            @if (sending()) {
                <app-bx-spinner></app-bx-spinner>
            } @else if (selectedHasNoEmail) {
                Update &amp; send invitation
            } @else {
                Send invitation
            }
        </button>
    </div>
</footer>
